// 수행평가
import Resource from '../Resource'
import axios from 'axios'
export default class Scores extends Resource {
  static ENDPOINT = '/api/test/score'

  constructor (args) {
    super()
    this.extend(args)
  }

  static async getTestScore (obj) {
    const res = await axios.get(`${this.ENDPOINT}/gettestscore`, { params: obj });
    return res.data && new this(res.data);
  }
}
